<div mat-dialog-content>
    <app-search-routes (routeSelected)="onRouteSelected($event)"></app-search-routes>
</div>